import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SnackbarService } from '../error/snackbar.service';
import { TeamListDto } from '../../models/teams/team-list-dto';
import { TeamDetailsDto } from '../../models/teams/team-details-dto';
import { UpdateTeamModel } from '../../../views/teams-view/components/team-details/team-details.component';
import { SnackbarConfig, SnackbarPosition, SnackbarType } from '../../enums/snackbar-config';
import { UpdateTeamResponseModel } from '../../models/teams/update-team-response.model';
import { Operation } from 'fast-json-patch/module/core';
import { browserOnly } from './browser-only.util';

@Injectable({
  providedIn: 'root'
})
export class TeamApiService {
  private apiUrl = environment.apiBaseUrl;

  constructor(
    private http: HttpClient,
    private snackBarService: SnackbarService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  getTeamList(): Observable<TeamListDto[]> {
    let url = `${this.apiUrl}/teams`;
    return browserOnly<TeamListDto[]>(this.platformId, [], () => this.http.get<TeamListDto[]>(url).pipe(catchError(error => this.snackBarService.handleApiError(error))));
  }

  getTeam(id: number): Observable<TeamDetailsDto> {
    return browserOnly<TeamDetailsDto>(this.platformId, {} as TeamDetailsDto, () => this.http.get<TeamDetailsDto>(`${this.apiUrl}/team/${id}`).pipe(catchError(error => this.snackBarService.handleApiError(error))));
  }

  updateTeam(team: UpdateTeamModel): Observable<UpdateTeamResponseModel> {
    return browserOnly<UpdateTeamResponseModel>(this.platformId, {} as UpdateTeamResponseModel, () => this.http.put<UpdateTeamResponseModel>(`${this.apiUrl}/team/${team.id}`, team, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    }).pipe(tap((response) => {
      if (response.deactivatedMachines && response.deactivatedMachines.length > 0) {
        this.snackBarService.showResponse(`Maskinlag ${team.teamId} sparat. Maskiner inaktiverade: ${response.deactivatedMachines.join(", ")}`, SnackbarConfig.combine(SnackbarType.SUCCESS, SnackbarPosition.BOTTOM))
        return;
      }
      this.snackBarService.showResponse(`Maskinlag ${team.teamId} sparat.`, SnackbarConfig.combine(SnackbarType.SUCCESS, SnackbarPosition.BOTTOM))
    }),
      catchError(error => this.snackBarService.handleApiError(error))
    ))
  }

  patchTeam(id: number, teamIdentifier: string, operations: Operation[]): Observable<UpdateTeamResponseModel> {
    return browserOnly<UpdateTeamResponseModel>(this.platformId, {} as UpdateTeamResponseModel, () => this.http.patch<UpdateTeamResponseModel>(`${this.apiUrl}/team/${id}`, operations, {
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json"
      })
    }).pipe(tap((response) => {
      if (response.deactivatedMachines && response.deactivatedMachines.length > 0) {
        this.snackBarService.showResponse(`Maskinlag ${teamIdentifier} sparat. Maskiner inaktiverade: ${response.deactivatedMachines.join(", ")}`, SnackbarConfig.combine(SnackbarType.SUCCESS, SnackbarPosition.BOTTOM));
        return;
      }

      this.snackBarService.showResponse(`Maskinlag ${teamIdentifier} sparat.`, SnackbarConfig.combine(SnackbarType.SUCCESS, SnackbarPosition.BOTTOM))
    }),
      catchError(error => this.snackBarService.handleApiError(error))
    ));
  }
}
